'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './violations-ticket-show.routes';

export class ViolationsTicketShowComponent {
  constructor($state, $stateParams, dialogs, ViolationTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems, $timeout) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.Auth = Auth;
    this.ticketId = $stateParams.id;
    this.prompt = prompt;
    this.tasks = [];

    this.activities = [];
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;

    this.dialogs = dialogs;
    this.ViolationTicketsService = ViolationTicketsService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.$state = $state;

    this.hook = {
      openSendAttachmentModal: this.openSendAttachmentModal.bind(this)
    };

    this.refreshData();
  }

  addToAttachments(id, level) {
    var that = this;

    let mapType = {
      'primary-owner': 'Primary Owner',
      'owner': 'Owner',
      'renter': 'Renter',
      'tenant': 'Tenant',
      'previous-owner': 'Previous Owner'
    };

    let addresses = [];

    if (this.ticket.property && this.ticket.property.address && this.ticket.property.address.street) {
      let propertyAddress = angular.copy(this.ticket.property.address);
      propertyAddress.type = 'Property';
      propertyAddress.group = "Property Address";
      addresses.push(propertyAddress);
    }

    if (this.ticket.property && this.ticket.property.contacts && this.ticket.property.contacts.length) {
      this.ticket.property.contacts.forEach(contact => {
        if (contact.contact && contact.contact.address && contact.contact.address.length) {
          contact.contact.address.forEach(adr => {
            let contactAddress = angular.copy(adr);
            contactAddress.firstName = contact.contact.firstName;
            contactAddress.lastName = contact.contact.lastName;
            contactAddress.group = contact.contact.firstName + ' ' + contact.contact.lastName + ' (' + mapType[contact.type] + ')';
            addresses.push(contactAddress);
          });
        }
      });
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'letterAddressSelectModal',
      resolve: {
        config: function() {
          return {
            addresses
          }
        }
      },
      size: 'sm'
    });

    modalInstance.result.then(
      function (address) {
        let base64Adr = btoa(JSON.stringify(address));
        that.ViolationTicketsService.createPDFAndAttach({id, level, address: base64Adr}, _ => {
          that.refreshData();
        });
      },
      function () { /* cancel */ }
    );

  }

  getLetter(id, level, filetype) {
    var that = this;

    let mapType = {
      'primary-owner': 'Primary Owner',
      'owner': 'Owner',
      'renter': 'Renter',
      'tenant': 'Tenant',
      'previous-owner': 'Previous Owner'
    };

    let addresses = [];

    if (this.ticket.property && this.ticket.property.address && this.ticket.property.address.street) {
      let propertyAddress = angular.copy(this.ticket.property.address);
      propertyAddress.type = 'Property';
      propertyAddress.group = "Property Address";
      addresses.push(propertyAddress);
    }

    if (this.ticket.property && this.ticket.property.contacts && this.ticket.property.contacts.length) {
      this.ticket.property.contacts.forEach(contact => {
        if (contact.contact && contact.contact.address && contact.contact.address.length) {
          contact.contact.address.forEach(adr => {
            let contactAddress = angular.copy(adr);
            contactAddress.firstName = contact.contact.firstName;
            contactAddress.lastName = contact.contact.lastName;
            contactAddress.group = contact.contact.firstName + ' ' + contact.contact.lastName + ' (' + mapType[contact.type] + ')';
            addresses.push(contactAddress);
          });
        }
      });
    }

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'letterAddressDownloadModal',
      resolve: {
        config: function() {
          return {
            endpoint: 'violations',
            id,
            level,
            filetype,
            addresses
          }
        }
      },
      size: 'sm'
    });

    modalInstance.result.then(
      function () {
        that.refreshAttachments();
      },
      function () {
        that.refreshAttachments();
      }
    );

  }

  getEmails() {
    let emails = [];

    this.ticket.property.contacts.forEach(entry => {
      if (!entry.contact || typeof entry.contact !== 'object')
        return;

      entry.contact.email.forEach(email => {
        let group = entry.contact.firstName + " " + entry.contact.lastName + " (" + entry.type.replace("-", " ").toUpperCase() + ")";

        let description = email.address + " (" + email.type + ")";

        if (email.isPrimary) {
          description += " (PRIMARY)"
        }

        emails.push({
          group: group,
          email: email.address,
          description: description
        })
      })
    });

    return emails;
  }

  openSendAttachmentModal(attachment) {
    var that = this;

    let primary = (that.ticket.property && that.ticket.property.contacts)
      ? that.ticket.property.contacts.find(contact => contact.type == 'primary-owner')
      : null;

    let owner = (primary && primary.contact)
      ? `${primary.contact.firstName} ${primary.contact.lastName}`
      : '-';

    let mailAddr1 = (that.ticket.property && that.ticket.property.address)
      ? that.ticket.property.address.street
      : '';

    let mailAddr2 = (that.ticket.property && that.ticket.property.address && that.ticket.property.address.street2)
      ? that.ticket.property.address.street2
      : '';

    let stateCityZip = (that.ticket.property && that.ticket.property.address)
      ? `${that.ticket.property.address.city}, ${that.ticket.property.address.state} ${that.ticket.property.address.zip}`
      : '';

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'sendAttachmentEmail',
      resolve: {
        config: function() {
          return {
            //email: 'hunzkunz@lorem.net',
            attachment: (attachment) ? attachment._id : null,
            attachments: that.ticket.attachments.filter(attachment => attachment.contentType !== 'text/html'),
            emails: that.getEmails(),
            templates: that.ticket.sequence,
            contextVars: {
              ASSOCIATION_NAME: that.ticket.property.community.name,
              VIOLATION: that.ticket.code + ': ' + that.ticket.name,
              ARTICLE: (that.ticket.article) ? that.ticket.article.split(/\n/).join("<br/>") : '',
              RESOLVE_BY: (that.ticket.resolveBy) ? that.ticket.resolveBy.split(/\n/).join("<br/>") : '',
              DESCRIPTION: (that.ticket.description) ? that.ticket.description.split(/\n/).join("<br/>") : '',
              TODAYS_DATE: moment().format('l'),
              LEVEL2_DAYS: (that.ticket.sequence[1]) ? that.ticket.sequence[1].days : '-',
              LEVEL3_DAYS: (that.ticket.sequence[2]) ? that.ticket.sequence[2].days : '-',
              LEVEL4_DAYS: (that.ticket.sequence[3]) ? that.ticket.sequence[3].days : '-',
              LEVEL5_DAYS: (that.ticket.sequence[4]) ? that.ticket.sequence[4].days : '-',
              OWNER_NAME: owner,
              MAILING_ADDRESS_LINE_1: mailAddr1,
              MAILING_ADDRESS_LINE_2: mailAddr2,
              MAILING_STATE_CITY_ZIP: stateCityZip,
              PROPERTY_STREET_ADDRESS: mailAddr1,
              ENTITY_LINK: `<a target='_blank' href='http://192.168.178.47:3000/violation/ticket/detail/${that.ticket._id}'>Open Violation in Management Suite</a>`
            }
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (mail) {

        //TODO: delete !!!!!
        //mail.email = "h.muenzel@iba-tech.de";

        that.ViolationTicketsService.sendAttachmentMail({id: that.ticketId}, mail, _ => {
            that.refreshData();
        }, err => { console.log(err) })
      },
      function () { /* cancel */ }
    );

  }

  refreshAttachments() {
    let count = this.ticket.attachments.length;
    
    /* Nice Code :) */
    this.$timeout(_=> {
      this.refreshData(_=>{
        if (this.ticket.attachments.length === count) {
          this.$timeout(_=> {
            this.refreshData(_=>{
              if (this.ticket.attachments.length === count) {
                this.$timeout(_=> {
                  this.refreshData(_=>{
                    if (this.ticket.attachments.length === count) {
                      this.$timeout(_=> {
                        this.refreshData();
                      }, 10000);
                    }
                  });
                }, 5000);
              }
            });
          }, 2500);
        }
      });
    }, 2500);
  };

  refreshData(cbDone) {
    if (this.ticketId) {
      this.ViolationTicketsService.get({id: this.ticketId}, data => {
        this.ticket = data;

        this.RecentVisits.addWorkItem(this.ticketId, "ccr", `${this.ticket.code}: ${this.ticket.name}`);
        this.isPinned = this.PinnedItems.isPinnedWorkItem(this.ticketId);

        this.ticket.sequence.forEach(lvl => {
          lvl.dueDate = moment(this.ticket.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
        });

        if (cbDone) {
          cbDone();
        }
      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  changeState() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'stateChangeForm',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (stateChange) {
        that.ticket.status = stateChange.status;

        if (stateChange.reason) {
          that.ticket.notes.push({
            meta: {
              creationUser: that.Auth.getCurrentUserSync()._id
            },
            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
          })
        }

        if (stateChange.status == 'open') { // it was closed
          delete that.ticket.closeDate;     // then remove close date
        } else {
          that.ticket.closeDate = new Date(); // otherwise now it is closed
        }

        that.ViolationTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }

  takeActionLevel(idx) {
    //this.ticket.sequence[idx].active = true;

    this.ViolationTicketsService.patch({id: this.ticketId},[
      { "op": "replace", "path": "/sequence/"+idx+"/active", "value": "true" }
    ], _ => {
      this.ViolationTicketsService.get({id: this.ticketId}, data => {
        this.ticket = data;

        this.ticket.sequence.forEach(lvl => {
          lvl.dueDate = moment(this.ticket.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
        })
      }, err => {
        console.log('Could not load violation ticket from server');
      });
    });
  }

  showButtonTakeAction(idx) {
    if (this.ticket.sequence[idx].active)
      return false;

    if (idx == 0)
      return true;

    return (this.ticket.sequence[idx - 1].active == true);
  }

  showButtonPrintLetter(idx) {
    return this.ticket.sequence[idx].active;
  }

  showStateCurrent(idx) {
    if (!this.ticket.sequence[idx].active)
      return false;
    
    if (idx < this.ticket.sequence.length-1 && !this.ticket.sequence[idx + 1].active)
      return true;

    if (idx == this.ticket.sequence.length-1)
      return true;

    return false;
  }

  showStateNext(idx) {
    if (!this.ticket.sequence[idx].active && idx == 0)
      return true;

    if (!this.ticket.sequence[idx].active && idx > 0 && this.ticket.sequence[idx-1].active)
      return true;

    return false;
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.ViolationTicketsService.addAttachments({id: that.ticketId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to ticket');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.violationsTicketShow', [uiRouter])
  .config(routes)
  .component('violationsTicketShow', {
    template: require('./violations-ticket-show.html'),
    controller: ViolationsTicketShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/violations/ticket-show/violations-ticket-show.component.js